export enum DashboardTourStatusEnum {
  COMPLETED = "completed",
  SKIPPED = "skipped",
}
